function SearchIcon() {
    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.005 16.995C17.2784 17.2683 17.7216 17.2683 17.995 16.995C18.2683 16.7216 18.2683 16.2784 17.995 16.005L17.005 16.995ZM13.505 13.495L17.005 16.995L17.995 16.005L14.495 12.505L13.505 13.495Z"
                fill="#A5AAAF"/>
            <circle cx="11.5" cy="10.5" r="3.8" stroke="#A5AAAF" strokeWidth="1.4"/>
        </svg>
    );
}

export default SearchIcon;
